<div class="progress-bar">

      <div class="progress-margin" class="app-title" translate='progress.title'></div>  

      <div role="menu" class="progress-margin"  (click)="onProgressMenu()" alt-text='menu.progress_menu_alt'>

            <progress class="mobile-left" max="100" 
                  value="{{progress.currentIndex}}">
            </progress>
            
                  
            <i class="glyphicon glyphicon-menu-hamburger mobile-right"  style="font-size:1.2em; margin:0.48em 0.3em  0 0"
               tabindex="0" id="progressbarmobile" (keypress)="keyPress($event)">
                  <span translate='menu.progress_menu' class="sr-only"></span>
            </i>        
            
            <div class="desktop-right">
                  <div class="progress-menu" tabindex="0" (keypress)="keyPress($event)" id="progressbar">
                        <i class="glyphicon glyphicon-menu-hamburger" 
                           style="vertical-align:middle; padding-bottom:0.3em"></i>  
                        <span style="margin-left:0.4em;" translate='menu.progress_menu'></span>
                  </div>
            </div>

            <br style="clear:both"/>
      </div>
      <div class="progress-margin" style="font-size:0.86em; padding-left:0.6em;">
           {{progress.currentLabel}}
      </div>
</div>

<div [hidden]="!progress.isOpened" style="margin:0" id="popup_menu">
      <div class="popup-out menu-margin">
            <div class="popup-in" style="width:100%;">
                  <progress-menu (menuSelected)="onMenuSelected()"></progress-menu>
            </div>
      </div>
      <div class="box-background"></div>
</div>
